/** Сохранение активной вкладки карточки ДО в sessionStorage. */

function hashQueryString() {
  const hash = window.location.hash || ''
  const i = hash.indexOf('?')
  return i >= 0 ? hash.slice(i + 1) : ''
}

/** Параметр из hash-URL (не для вкладок; например from=complete_approval в заявках). */
export function readTabQueryParam(paramName) {
  const value = new URLSearchParams(hashQueryString()).get(paramName)
  return value ? decodeURIComponent(value) : null
}

function storageKey(projectName, objectId) {
  return `sigur_doc_tab:${projectName}:${objectId}`
}

export function readTabFromStorage(projectName, objectId) {
  if (!projectName || !objectId) return null
  try {
    return sessionStorage.getItem(storageKey(projectName, objectId))
  } catch {
    return null
  }
}

export function writeTabToStorage(projectName, objectId, tabTitle) {
  if (!projectName || !objectId) return
  try {
    sessionStorage.setItem(storageKey(projectName, objectId), tabTitle)
  } catch {
    /* ignore */
  }
}

export function resolveDocTab({ tabs, firstTab, preferTab, projectName, objectId }) {
  const isValid = (title) => title && tabs.includes(title)

  if (isValid(preferTab)) return preferTab

  const fromStorage = readTabFromStorage(projectName, objectId)
  if (isValid(fromStorage)) return fromStorage

  return firstTab
}

export function persistDocTab(projectName, objectId, tabTitle) {
  writeTabToStorage(projectName, objectId, tabTitle)
}
